module.exports = __webpack_public_path__ + "img/illustration-02.456bfecc.png";